import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { GlobalErrorHandler } from './services/global-error-handler';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApiInterceptor } from './security/api.interceptor';
import { ApiEncryptionInterceptor } from './security/api-encryption.interceptor';
import { ENCRYPTION_BYPASS } from './services/encryption.service';
import { RsaKeyService } from './services/rsa-key.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
import localeDu from '@angular/common/locales/nds-NL';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeJa from '@angular/common/locales/ja';
import localeKr from '@angular/common/locales/ko';
import localePt from '@angular/common/locales/pt';
import localeZh from '@angular/common/locales/zh';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { EmployeeStbExitComponent } from './pages/stb/employee-stb-exit/employee-stb-exit.component';
// import { NoticeOnboardingComponent } from './pages/notice-onboarding/notice-onboarding.component';

// Aquí registras los datos de localización para español
registerLocaleData(localeEs);
registerLocaleData(localeDu);
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeJa);
registerLocaleData(localeKr);
registerLocaleData(localePt);
registerLocaleData(localeZh);

@NgModule({
  declarations: [
    AppComponent,
    // NoticeOnboardingComponent,
  ],
  bootstrap: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    SharedModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es-MX',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GoogleTagManagerModule.forRoot({
      id: 'GTM-5B53Z5QG',
    }),
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    // Debe ir después de ApiInterceptor: cifra/descifra lo más cerca del backend.
    { provide: HTTP_INTERCEPTORS, useClass: ApiEncryptionInterceptor, multi: true },
    // Pregenera el par RSA de la sesión en cuanto la app queda ociosa (el keygen bloquea).
    provideAppInitializer(() => {
      if (!inject(ENCRYPTION_BYPASS)) {
        inject(RsaKeyService).preload();
      }
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
